import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const button = dom.find('[aria-expanded]');
    const description = dom.find('[data-description]');

    const toggle = () => {
        const shouldOpen = button.attr('aria-expanded') === 'false';

        if (shouldOpen) {
            button.attr('aria-expanded', true).attr('aria-label', button.data('close'));
            description.attr('hidden', null);
        } else {
            button.attr('aria-expanded', false).attr('aria-label', button.data('label'));
            description.attr('hidden', '');
        }
    };

    const init = () => {
        button.data('label', button.attr('aria-label'));
        button.on('click', toggle);
    };

    const destroy = () => {
        button.off('click', toggle);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ResourceToggle.js